import classNames from 'classnames'
import * as React from 'react'
import {useLocation} from 'react-router-dom'

import {useQueryParam} from '../../../../../../hooks/routes'
import {Routes, getAgentHref, matchRoute} from '../../../../../../routes'
import {getCanViewAgentDetails} from '../../../../../../selectors'
import type {KeyValue} from '../../../../../../utils/object'
import SidebarLink, {
  InactiveSidebarLink,
} from '../../../../../common/Sidebar/SidebarLink/SidebarLink'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'
import LinearAgent from '../../../components/LinearAgent/LinearAgent'
import type {AgentsTreeItemAgent} from '../../AgentsSidebar.types'
import {AgentTreeItemCategory} from '../../AgentsSidebar.types'
import {getAgentsTreeSearchState} from '../../selectors/getExpand'

import styles from './Agent.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = AgentsTreeItemAgent & {
  className?: string
  style?: KeyValue<string, string | number>
}
function Agent({
  id,
  title,
  busy,
  connected,
  enabled,
  authorized,
  cloud,
  matching,
  className,
  style,
  osType,
  category,
}: Props) {
  const canViewAgentDetails = useAppSelector(getCanViewAgentDetails)
  let tail: React.ReactNode = authorized && busy !== true ? 'idle' : null

  if (connected !== true) {
    tail = (
      <React.Fragment>
        {tail && <span className={styles.idle}>{tail}</span>}
        <SvgIcon
          className={styles.disconnectedIcon}
          icon="disconnected"
          title="disconnected"
          data-test-sidebar-agent={'disconnected-icon'}
        />
      </React.Fragment>
    )
  } else if (enabled !== true) {
    tail = cloud ? 'maintenance' : 'disabled'
  }

  let agentHref = getAgentHref(id, category === AgentTreeItemCategory.MAIN)
  const location = useLocation()
  const tab = useQueryParam('tab')

  if (matchRoute(Routes.AGENT, location) != null && tab != null) {
    agentHref = `${agentHref}?tab=${tab}`
  }

  const {searchQuery} = useAppSelector(getAgentsTreeSearchState)
  const linkContent = (
    <LinearAgent
      title={title}
      osType={osType}
      enabled={enabled}
      cloud={cloud}
      matching={matching}
      searchQuery={searchQuery}
    />
  )
  const linkProps = {
    className: classNames(className, {[styles.disconnected]: !connected}),
    style,
    ['aria-label']: title,
    tail,
  }

  return canViewAgentDetails ? (
    <SidebarLink to={agentHref} tabIndex={-1} {...linkProps}>
      {linkContent}
    </SidebarLink>
  ) : (
    <InactiveSidebarLink {...linkProps}>{linkContent}</InactiveSidebarLink>
  )
}
export default React.memo<Props>(Agent)
